import { useEnvironmentStore } from "../stores/environment.store";
import { useProfileStore } from "../stores/profile.store";
import { useSettingsStore } from "../stores/settings.store";
import { CookieFacade } from "./cookie.facade";
import { MenuFacade } from "./menu.facade";
import { RouteFacade } from "./route.facade";
import { ToastFacade } from "./toast.facade";
import { TokenFacade } from "./token.facade";

export function useFacade() {
    const cookie = new CookieFacade();
    const profileStore = useProfileStore();

    return {
        cookie: cookie,
        menu: new MenuFacade(),
        route: new RouteFacade(),
        token: new TokenFacade(cookie),
        profile: profileStore.data!,
        isTesting: import.meta.env.MODE !== "production",
        env: useEnvironmentStore(),
        settings: useSettingsStore(),
        createURL: (suffix: string) => {
            if (import.meta.env.SSR) return suffix;
            return `${window.location.protocol}//${window.location.host}${suffix}`;
        },
    };
}

export function useToastFacade() {
    return new ToastFacade();
}
